const products = {
    products: {
        HaifaStimBooster: "Verhoogt metabolische activiteit in stressvolle situaties",
        HaifaStimEnergy: "Verbetert de energiehuishouding van de plant",
        HaifaStimForce: "Bespaart metabolische energie: ondersteunt de aminozuur- en eiwitsynthese",
        HaifaStimHumiK: "Ondersteunt de wortelactiviteit en opname van voedingsstoffen",
        HaifaStimVigor: "Versterkt en verbetert de weerstand van planten tegen abiotische stress",
        HaifaStimVIM: "Verbetert bodemvruchtbaarheid en efficiëntie van nutriëntengebruik",
        HaifaStimVital: "Verbetert plantprestaties",
        HaifaStimWallUp:
            "Optimale mix van geselecteerde micronutriënten voor het verbeteren van de plantweerstand tegen abiotische stress: verbetert de groei en maximaliseert de opbrengst",
        HaifaMicroCombi:
            "Een stabiel: in water oplosbaar en stofvrij mengsel van metaalchelaten: ijzer: mangaan: koper: zink: die allemaal in EDTA-gechelateerde vorm aanwezig zijn",
        PolyFeedFoliar1:
            "Poly-Feed™ Foliar voedt planten en voorziet ze in hun precieze behoeften tijdens kritieke groeifasen: voor maximale opbrengsten en topkwaliteit.",
        PolyFeedFoliar2: "Gewasspecifieke formule",
        PolyFeedStim: "unieke combinatie van natuurlijke stimulerende middelen en minerale NPK-meststoffen",
        HaifaBonus: "Meststofformuleringen met hoog kaliumgehalte voor efficiënte bladtoepassing zijn gebaseerd op Multi-K™ kaliumnitraat van Haifa.",
    },
};

export default products;
